import { FlowChartNodeI } from '@interfaces/flow-chart-node.interface';
import { FlowI } from '@interfaces/flow.interface';
import { createAction, props } from '@ngrx/store';
import { ActionMessages, SubFlowStore } from '@omnitypes/step-actions';

export const addMessage = createAction('[Step Actions] addMessage', props<{ payload: ActionMessages }>());
/** Substitui actions + subFlows + detached de uma vez (usado por Desfazer/Refazer). */
export const setActionsSnapshot = createAction(
  '[Step Actions] setActionsSnapshot',
  props<{ actions: ActionMessages[]; subFlows: SubFlowStore[]; detachedActions?: ActionMessages[] }>()
);
/** Preserva uma ação removida do fluxo na lista "Criadas" (reutilizável). */
export const detachAction = createAction('[Step Actions] detachAction', props<{ payload: ActionMessages }>());
/** Remove definitivamente uma ação preservada. */
export const removeDetachedAction = createAction('[Step Actions] removeDetachedAction', props<{ id: string }>());
export const addSubFlow = createAction('[Step Actions] add subFlow', props<{ payload: SubFlowStore }>());
export const addAllSubFlows = createAction('[Step Actions] add all subFlows', props<{ payload: SubFlowStore[] }>());
export const updateSubFlow = createAction('[Step Actions] update subFlow', props<{ payload: SubFlowStore }>());
export const addMessageSubFlow = createAction(
  '[Step Actions] add message subFlow',
  props<{ payload: ActionMessages; subFlowId?: string }>()
);
export const updateMessageSubFlow = createAction(
  '[Step Actions] update message subFlow',
  props<{ payload: Partial<ActionMessages> }>()
);
export const updateMessage = createAction(
  '[Step Actions] updateMessage',
  props<{ payload: Partial<ActionMessages> }>()
);
export const addMessages = createAction('[Step Actions] addMessages', props<{ payload: ActionMessages[] }>());
export const cleanMessage = createAction('[Step Actions] cleanMessage');
export const cleanLastActionAdded = createAction('[Step Actions] clean Last Action Added');
export const positionAfterAction = createAction(
  '[Step Actions] addPosistionAfterAction',
  props<{ payload: { index?: number } }>()
);
export const removeMessage = createAction('[Step Actions] removeMessage', props<{ payload: ActionMessages }>());
export const removeMessageSubFlow = createAction(
  '[Step Actions] removeMessageSubFlow',
  props<{ payload: { action: ActionMessages; subFlowId: string } }>()
);

export const removeSubFlow = createAction('[Step Actions] removeSubFlow', props<{ payload: { id: string } }>());

export const setConditionalPath = createAction(
  '[Step Actions] set conditional path',
  props<{ payload: { id: string; parent: string } }>()
);
export const addOneIndexSelectActionBox = createAction('[Step Actions] toggleSelectActionBox');
export const toggleSelectActionBox = createAction(
  '[Step Actions] toggleSelectActionBox',
  props<{ isVisible: boolean }>()
);
export const setSelectActionBoxPosition = createAction(
  '[Step Action] SetSelectActionBoxPosition',
  props<{ position: number | undefined; subFlowId?: string; parentActionType?: string; subFlowName?: string }>()
);

export const setSelectedConditionals = createAction(
  '[Step Action] setSelectedConditionals',
  props<{ payload: any[] }>()
);

export const setSubFlowIdActionClicked = createAction(
  '[Step Action] setSubFlowIdActionClicked',
  props<{ subFlowId?: string }>()
);
export const inserIntoPosition = createAction(
  '[Step Action] InsertIntoPosition',
  props<{ payload: ActionMessages; position: number }>()
);

export const setFlow = createAction('[Set Flow] setFlow', props<{ payload: Partial<FlowI> }>());
export const selectAction = createAction('[Select ActionID] selectActionID', props<{ payload: any }>());
export const removeOptionCondition = createAction(
  '[Remove Option] Condition',
  props<{ payload: { optionId: string; id?: string; actionId: string } }>()
);

export const addedNewItem = createAction('[addedNewItem]');
export const setNewItemPosition = createAction(
  '[setNewItemPosition',
  props<{ payload: { posX: number; posY: number } }>()
);
export const addUpdatedSubflowIdFlowDesign = createAction(
  '[Step Action] addUpdatedSubflowIdFlowDesign',
  props<{ subflowId: string }>()
);
export const clearUpdatedSubflowIdFlowDesign = createAction('[Step Action] clearUpdatedSubflowIdFlowDesign');

export const updateAllActionPositions = createAction(
  '[Step Action] updateAllActionPositions',
  props<{ nodes: FlowChartNodeI[] }>()
);
